<template>
    <div
        class="s2w-family-selector-container"
        :class="{
            disabled,
        }"
    >
        <div
            class="s2w-family-switch"
            :class="{ enable }"
            @click="toggleFamily()"
        />
        <div class="s2w-family-desc">
            {{ $t(`BaseSaveToWorkspace.RangeSelector.family.label`) }}
        </div>
        <div
            v-if="enable"
            class="s2w-family-selector"
        >
            <div
                class="s2w-family-selector-current"
                :class="{
                    active: showFamilyPopper,
                }"
                @mousedown.stop
                @click.stop="showFamilyPopper = !showFamilyPopper"
            >
                <template v-if="selected">
                    <div class="s2w-family-selector-label">
                        {{ $t(`BaseSaveToWorkspace.RangeSelector.family.types.${selected.value}`) }}
                    </div>
                    <PtIcon
                        v-if="selected.loading"
                        icon="SolidLoadingBars"
                        style="font-size: 24px;"
                    />
                    <div v-else-if="selected.count >= 0">
                        ({{ service.formatNumber(selected.count) }})
                    </div>
                </template>
                <PtIcon
                    style="font-size: 24px;"
                    :icon="showFamilyPopper ? 'SolidDropdownClose' : 'SolidDropdownOpen'"
                />
            </div>
            <div
                v-if="showFamilyPopper"
                class="s2w-family-selector-popper"
                @mousedown.stop
            >
                <div
                    v-for="item in familyExpansions"
                    :key="item.value"
                    class="s2w-family-selector-item"
                    :class="{ current: selected === item }"
                    @click="selectFamilyExpansion(item)"
                >
                    <div class="s2w-family-selector-item-info">
                        <div class="s2w-family-selector-label">
                            {{ $t(`BaseSaveToWorkspace.RangeSelector.family.types.${item.value}`) }}
                        </div>
                        <PtIcon
                            v-if="item.loading"
                            icon="SolidLoadingBars"
                            style="font-size: 24px;"
                        />
                        <div v-else-if="selected.count >= 0">
                            ({{ service.formatNumber(item.count) }})
                        </div>
                    </div>
                    <PtIcon
                        class="s2w-family-selector-item-tick"
                        icon="SolidTick"
                        style="font-size: 24px;"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'FamilySelector',
    components: {
        PtIcon,
    },
    inject: ['service'],
    data() {
        return {
            showFamilyPopper: false,
        };
    },
    computed: {
        enable() {
            return this.service.rangeSelector.family.enable;
        },
        disabled() {
            const { rangeSelector: { selectedType }, disabledAllType, enableRange } = this.service;

            if (selectedType === 'RANGE') return true;

            if (enableRange && disabledAllType) return true;

            return false;
        },
        familyExpansions() {
            return this.service.rangeSelector.family.familyExpansions;
        },
        selected() {
            return this.service.rangeSelector.family.selected;
        },
    },
    created() {
        this.closeFamilyPopper = () => {
            this.showFamilyPopper = false;
        };
        document.addEventListener('mousedown', this.closeFamilyPopper);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.closeFamilyPopper);
    },
    methods: {
        selectFamilyExpansion(item) {
            this.service.selectFamilyExpansion(item);
            this.showFamilyPopper = false;
        },
        toggleFamily() {
            if (this.disabled) return false;
            this.service.toggleFamily();
            return true;
        },
    },
};
</script>
